import QuestionOutlined from '@ant-design/icons/QuestionOutlined';
import App from 'antd/es/app';
import Button from 'antd/es/button';
import { memo } from 'react';

// Using memo to prevent unnecessary re-renders
const HelpButton = memo(() => {
  const { modal } = App.useApp();

  const showHelpModal = () => {
    void modal.info({
      title: 'Need Help?',
      content: (
        <div>
          Please email any questions or feedback to{' '}
          <a href="mailto:support@catalyzed.ai">support@catalyzed.ai</a>
        </div>
      ),
      okText: 'Close',
    });
  };

  return (
    <Button shape="circle" onClick={showHelpModal}>
      <QuestionOutlined />
    </Button>
  );
});

HelpButton.displayName = 'HelpButton';

export default HelpButton;
